import Vue from 'vue'
import Router from './Router'

export default {
	namespaced: true,
	state: {
		list: [],
		meta: null,
		loading: true,
		detail: {},
		isLoadingCreateEmployer: false,
		isLoadingDetail: false
	},
	actions: {
		async fetch({ commit }, query) {
			let response = await Vue.http.get('employers', { params: query })
			commit('setList', response.body)
		},
		async createEmployer({ commit }, data) {
			try {
				commit('setLoadCreateEmployer', true)
				const response = await Vue.http.post(`employers`, data)
				commit('setLoadCreateEmployer', false)
				Router.push(`employers/${response.body.id}`)
			} catch (e) {
				console.error(e)
				commit('setLoadCreateEmployer', false)
			}
		},
		async getEmployer({ rootState, commit }, employerId = false) {
			try {
				commit('setLoadDetail', true)
				const id = employerId || rootState.route.params.employerId
				const response = await Vue.http.get(`employers/${id}`)
				commit('setDetail', response.body)
				commit('setLoadDetail', false)
				return response.body
			} catch (e) {
				commit('setLoadDetail', false)
			}
		},
		async updateEmployer({ rootState, dispatch }, data) {
			const id = rootState.route.params.employerId
			await Vue.http.post(`employers/${id}`, data)
			dispatch('getEmployer')
		},

		async createAddress({ rootState, commit }, data) {
			const id = rootState.route.params.employerId
			let response = await Vue.http.post(`addresses`, { ...data, addressable_id: id })
			data.id = response.body.addressId
			commit('addAddress', data)
		},
		async updateAddress({ commit }, data) {
			await Vue.http.post(`addresses/${data.id}`, data)
			commit('updateAddress', data)
		},
		async deleteAddress({ commit }, id) {
			await Vue.http.delete(`addresses/${id}`)
			commit('deleteAddress', id)
		}
	},
	mutations: {
		setList(state, employers) {
			state.list = employers.data
			state.meta = employers.meta
			state.loading = false
		},
		setDetail(state, employerDetail) {
			state.detail = { ...employerDetail }
		},
		setLoadCreateEmployer(state, status) {
			state.isLoadingCreateEmployer = status
		},
		setLoadDetail(state, status) {
			state.isLoadingDetail = status
		},

		addAddress(state, address) {
			state.detail[address.addressable_type] = state.detail[address.addressable_type]
				? [...state.detail[address.addressable_type], address]
				: address
		},
		updateAddress(state, address) {
			if(state.detail.employer_office_address.id == address.id) {
				state.detail.employer_office_address = address
			}
			state.detail.employer_work_address = state.detail.employer_work_address.map(
				item => {
					if(item.id === address.id) {
						item = address
					}
					return item
				}
			)
		},
		deleteAddress(state, addressId) {
			state.detail.employer_work_address = state.detail.employer_work_address.filter(
				item => item.id !== addressId
			)
		}
	}
}
